// https://github.com/kopoli/ya-openweathermap
import moment from 'moment'

angular.module('ya-openweathermap', [])
	.directive('yaOpenweathermap', function ($http, $filter, $stateParams) {
		'ngInject';
		return {
			restrict: 'EA',
			template: require('./weather.html'),
			link: function (scope, element, attrs) 
			{
				function datestr(dateint, fmt) {
					return $filter('date')(dateint, fmt)
				};

				function parseWeather(weather, half) {
					return {
						Temp: weather.main.temp.toFixed(),
						Pressure: weather.main.pressure,
						Humidity: weather.main.humidity,
						TempMin: weather.main.temp_min,
						TempMax: weather.main.temp_max,
						WindSpeed: weather.wind.speed,
						WindDegNumber: weather.wind.deg || 0,
						WindDeg: 'wi-wind towards-' + (weather.wind.deg || 0).toString() + '-deg',
						TimeInt: weather.dt,
						Sunrise: weather.sys.sunrise,
						Sunset: weather.sys.sunset,
						Icon: 'wi-owm-' + half + '-' + weather.weather[0].id.toString(),
						Desc: weather.weather[0].description,
					};
				}

				function parseDailyWeather(weather) {
					return {
						Temp: weather.temp.day.toFixed(),
						MornTemp: weather.temp.morn.toFixed(),
						EveTemp: weather.temp.eve.toFixed(),
						NightTemp: weather.temp.night,
						MinTemp: weather.temp.min.toFixed(),
						MaxTemp: weather.temp.max.toFixed(),
						Pressure: weather.pressure,
						Humidity: weather.humidity,
						TimeInt: weather.dt,
						Icon: 'wi-owm-' + weather.weather[0].id.toString(),
						Desc: weather.weather[0].description,
						WindSpeed: weather.speed,
						WindDeg: 'wi-wind towards-' + weather.deg.toString() + '-deg',
					};
				}

				$http.post('/api/frontend/event/weather/' + $stateParams.id)
				.then((response) =>
				{
					//console.log(response.data);
					// Current
					{
						let ret = response.data.current;

						var half = 'day';
						if (ret.sys.sunrise > ret.dt || ret.sys.sunset <= ret.dt)
							half = 'night';

						scope.cur = parseWeather(ret, half);
						scope.cur.Name = ret.name;
					}

					// Forecast
					{
						scope.forecast = [];

						for (var i in response.data.forecast.list) {
							
							scope.forecast.push(parseDailyWeather(response.data.forecast.list[i]))
						}
					}
				});

/*
				$http.get(current).then((response) => 
				{
					let ret = response.data;

					var half = 'day';
					if (ret.sys.sunrise > ret.dt || ret.sys.sunset <= ret.dt)
						half = 'night';

					scope.cur = parseWeather(ret, half, 'dd/MM/yy HH:mm');
					scope.cur.Name = ret.name;
				});

				$http.get(forecast).then((response) => 
				{
					scope.forecast = [];

					for (var i in response.data.list) {
						
						scope.forecast.push(parseDailyWeather(response.data.list[i], 'dd/MM'))
					}
				});
*/
			},
		}
	});


// WEBPACK FOOTER //
// ./client/components/weather/weather.js